module.exports = __webpack_public_path__ + "img/symbol-fraction-center.60251c97.png";